



























import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import { ROUTER_NAME } from '../../router'
import { LETTER_FORMAT } from '../../utils/constants'
import ExamResultWeb from '../atoms_molecules/ExamResultWeb.vue'
import ExamResultMobile from '../atoms_molecules/ExamResultMobile.vue'
import { GroupQuestion } from '../../../api/v2/models/question'
import ExamResultQuestionGroupList from '../atoms_molecules/ExamResultQuestionGroupList.vue'
import { headerState } from '../../stores/header'
import { examResultState } from '../../stores/exam_result'

@Component({
  components: {
    ExamResultWeb,
    ExamResultMobile,
    ExamResultQuestionGroupList
  }
})
export default class ExamResultQuestionList extends Vue {
  LETTER_FORMAT = LETTER_FORMAT
  mobile: boolean = false

  get exam() {
    return examResultState.examResult
  }

  get groupQuestions(): GroupQuestion[] {
    return examResultState.groupQuestions
  }

  get userExam() {
    if (this.userExamId) {
      return this.exam.userExams.find((userExam) => `${userExam.id}` == this.userExamId)
    }
    return this.exam.userExam
  }

  get redirectNotFoundPage() {
    return examResultState.redirectNotFoundPage
  }

  get userExamId() {
    return this.$route.query.user_exam_id as string
  }

  get examQScoreHistory() {
    return examResultState.examQScoreHistory
  }

  public mounted() {
    this.mobile = checkMobile()
    headerState.setTitle('問題一覧')

    if (this.groupQuestions.length == 0) {
      examResultState.requestExamResult(parseInt(this.$route.params.examId)).then(()=>{
        examResultState.setUserExamId(Number(this.userExamId))
        examResultState.getExamResultQuestions()
        examResultState.requestExamGroupQuestion(Number(this.$route.params.questionId))
        examResultState.requestExamQScoreHistories(parseInt(this.$route.params.examId))
      })
    }
  }

  back() {
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: this.$route.params.examId
      },
      query: this.$route.query
    })
  }

  @Watch('$route', {immediate: true})
  changeRoute(val) {
    examResultState.requestExamResult(parseInt(this.$route.params.examId))
    examResultState.requestExamQScoreHistories(parseInt(this.$route.params.examId))
  }

  @Watch('redirectNotFoundPage')
  changeRedirectNotFoundPage(val) {
    if (val) {
      examResultState.setRedirectNotFoundPage({ status: false })
      this.redirectToNotFoundPage()
    }
  }

  redirectToNotFoundPage() {
    this.$router.push({
      name: ROUTER_NAME.NOT_FOUND
    })
  }

  gotoTop(){
    this.$router.push({
      name: ROUTER_NAME.MY_EXAM_LIST
    })
  }

  getQuestionNumber(groupExamResultQuestion) {
    return (
      this.groupQuestions
        .filter((item) => item.questions.every((question) => !question.isDescriptionQuestion))
        .indexOf(groupExamResultQuestion) + 1
    )
  }
}
